import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import api from 'api';
import {
  ActiveSuggestedAction,
  SUGGESTED_ACTION_TYPE,
  SuggestedActionType,
} from 'router/subrouters/DataRoom/models/Dashboard';
import { DataRoomSubroute } from 'router/subrouters/DataRoom/models/DataRoom';
import {
  ACTIONED_SUGGESTED_ACTION_ACTION,
  ACTIONED_SUGGESTED_ACTION_NAME,
} from 'router/subrouters/DataRoom/pages/Dashboard/componenets/SuggestedActions/data';
import {
  getLeadBoardSuggestionSearch,
  isLeadBoardSuggestion,
} from 'router/subrouters/DataRoom/pages/Dashboard/componenets/SuggestedActions/utils';
import { getDataRoomRoute, getSellingPortfolio } from 'utils';
import { SUGGESTION_PAGE } from 'models/SuggestedActions';

const SUGGESTED_ACTION_SUBROUTE: Partial<
  Record<SuggestedActionType, DataRoomSubroute>
> = {
  [SUGGESTED_ACTION_TYPE.DATA_ROOM_EMPTY]: 'documents',
  [SUGGESTED_ACTION_TYPE.NO_FILES_LAST_10_DAYS]: 'documents',
  [SUGGESTED_ACTION_TYPE.UNREPLIED_QUESTIONS]: 'questions/questions-and-answers',
  [SUGGESTED_ACTION_TYPE.NO_FAQS]: 'questions/frequently-asked-questions',
  [SUGGESTED_ACTION_TYPE.PEOPLE_IN_WAITING_ROOM]: 'waiting-room',
  [SUGGESTED_ACTION_TYPE.SECURE_LINKS_EXPIRING]: 'shareable-links',
  [SUGGESTED_ACTION_TYPE.NEW_FILE_REQUEST]: 'rfi/list',
  [SUGGESTED_ACTION_TYPE.EMPTY_SECURE_LINKS]: 'shareable-links',
};

const SUGGESTED_ACTION_SEARCH: Partial<Record<SuggestedActionType, string>> = {
  [SUGGESTED_ACTION_TYPE.EMPTY_SECURE_LINKS]: '?sort=filesCount',
};

const useEnterpriseSuggestedActionNavigate = (
  dataRoomId: string,
  suggestion: ActiveSuggestedAction,
  dealRoomId?: string,
) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return useCallback(() => {
    const { type, count = 1 } = suggestion;

    api.enterpriseSuggestedActions.actionedSuggestedAction(dataRoomId, {
      suggestionName: t(ACTIONED_SUGGESTED_ACTION_NAME[type], { count }),
      suggestionAction: t(ACTIONED_SUGGESTED_ACTION_ACTION[type], { count }),
      suggestionPage: SUGGESTION_PAGE.ENTERPRISE_DASHBOARD,
    });

    if (isLeadBoardSuggestion(type)) {
      const leadBoardDealRoomId = dealRoomId ?? suggestion.dealRoomId;

      if (!leadBoardDealRoomId) return;

      navigate({
        pathname: getSellingPortfolio(leadBoardDealRoomId, 'leads'),
        search: getLeadBoardSuggestionSearch(suggestion),
      });

      return;
    }

    navigate({
      pathname: getDataRoomRoute(dataRoomId, SUGGESTED_ACTION_SUBROUTE[type]),
      search: SUGGESTED_ACTION_SEARCH[type],
    });
  }, [dataRoomId, dealRoomId, navigate, suggestion, t]);
};

export default useEnterpriseSuggestedActionNavigate;
